export default __webpack_public_path__ + "static/media/browser-1.82171778.png";